export enum AttachmentType {
    FILE = 1,
    FILE_EMBEDDED = 3,
    PREVIEW = 2
}